import React from "react";

const data = {
    intro: "Hi! I am Ji Ma(马骥). I am an CS Ph.D. student at State Key Lab of CAD&CG, Zhejiang University, advised by Prof. Yingcai Wu. ",
    contact: [
        {
            src: './imgs/email.png',
            name: 'jimazju [at] gmail [dot] com',
            link: 'mailto:jimazju@gmail.com'
        },
        {
            src: './imgs/googlescholar.png',
            name: 'Google Scholar',
            link: 'https://scholar.google.com/citations?user=vz6ryCwAAAAJ&hl=en'
        }
    ],
    // education: [
    //     {
    //         duration: 'Aug. 2023 - Present',
    //         city: 'Hangzhou',
    //         country: 'China',
    //         title: 'CS PH.D.',
    //         description: 'VIS & HCI,Supervised by Prof. Yingcai Wu',
    //         affiliation: 'School of Computer Science and Technology, Zhejiang University',
    //         src: './imgs/zju.png'
    //     },
    //     {
    //         duration: 'Aug. 2019 - June. 2023',
    //         city: 'Hangzhou',
    //         country: 'China',
    //         title: 'CS Undergraduate',
    //         affiliation: 'School of Computer Science and Technology, Zhejiang University',
    //         description: 'Member of Mixed Class in Chu Kochen Honors College',
    //         src: './imgs/zju.png'
    //     },
    // ],
    news: [
        {
            date: '08/2025',
            content: "Our paper T3Set is accepted by ACM KDD 2025!",
            // url: "https://kdd2025.kdd.org/"
        },
        // {
        //     date: '10/2024',
        //     content: "Zhejiang University’s running team claimed the Elite University Group title at the 2024 Nike University Elite Challenge, with members of the Kuafu Running Club playing a pivotal role.",
        //     url: "https://www.zju.edu.cn/english/2024/1021/c19573a2977710/page.psp"
        // },
        {
            date: '12/2023',
            content: "Our paper TacPrint is accepted by IEEE PacificVis 2024 TVCG journal track."
        },

        // {
        //     date: '08/2023',
        //     content: "I was interviewed by the press of Chu KoChen Honors College@ZJU",
        //     url: "https://mp.weixin.qq.com/s/DQAhExhmRTO7Sw6VgjpxeQ"
        // }
    ],
    experience: [
        {
            duration: 'Aug. 2023 - Present',
            city: 'Hangzhou',
            country: 'China',
            title: 'CS PH.D.',
            description: 'Data Mining | HCI, Supervised by Prof. Yingcai Wu',
            affiliation: 'School of Computer Science and Technology, Zhejiang University',
            src: './imgs/zju.png'
        },
        {
            duration: 'Aug. 2019 - June. 2023',
            city: 'Hangzhou',
            country: 'China',
            title: 'CS B.E.',
            affiliation: 'School of Computer Science and Technology, Zhejiang University',
            description: 'VIS4Sports, Supervised by Prof. Yingcai Wu since 2020. Member of Mixed Class in Chu Kochen Honors College.',
            src: './imgs/zju.png'
        },
    ],
    publications: [
        {
            title: 'T3Set: A Multimodal Dataset with Targeted Suggestions for LLM-based Virtual Coach in Table Tennis Training',
            authors: 'Ji Ma, Jiale Wu, Haoyu Wang, Yanze Zhang, Xiao Xie, Zheng Zhou, Hui Zhang, Jiachen Wang, Yingcai Wu',
            conference: 'The 31st ACM SIGKDD Conference on Knowledge Discovery and Data Mining (ACM KDD\'25) (CCF-A) - 2025',
            paper_url: 'https://zjuidg.org/source/projects/t3set/t3set.pdf',
            video_url: 'https://youtu.be/fW734qv0CT4',
            code_url: 'https://github.com/jima-cs/t3set',
            src: './imgs/t3set.png'
        },
        {
            title: 'CustMatcher: Enhancing preference-driven people-to-people recommendation',
            authors: 'Ji Ma,  Jiachen Wang, Xiao Xie, Zheng Zhou, Hui Zhang, Yingcai Wu',
            conference: 'Visual Informatics (JCR-Q1) - 2025',
            paper_url: 'https://www.sciencedirect.com/science/article/pii/S2468502X25000816',
            video_url: '',
            code_url: '',
            src: './imgs/CustMatcher.png'
        },
        {
            title: 'TacPrint: Visualizing the Biomechanical Fingerprint in Table Tennis',
            authors: 'Jiachen Wang, Ji Ma, Zheng Zhou, Xiao Xie, Hui Zhang, Yingcai Wu, Huamin Qu',
            conference: 'IEEE Transactions on Visualization and Computer Graphics (CCF-A, Top Journal in Visualization) - 2024',
            paper_url: 'https://zjuidg.org/source/projects/TacPrint/TacPrint.pdf',
            video_url: 'https://ieeexplore.ieee.org/ielx7/2945/4359476/10500518/supp1-3388555.mp4',
            code_url: '',
            src: './imgs/tacprint.png'
        },
        {
            title: 'Tac-Trainer: A Visual Analytics System for IoT-based Racket Sports Training',
            authors: 'Jiachen Wang, Ji Ma, Kangping Hu, Zheng Zhou, Hui Zhang, Xiao Xie, Yingcai Wu',
            conference: 'IEEE Transactions on Visualization and Computer Graphics (CCF-A, Top Journal in Visualization) - 2023',
            paper_url: 'https://zjuidg.org/source/projects/TacTrainer/TacTrainer.pdf',
            video_url: 'https://youtu.be/nriqaQUjZ1E',
            code_url: '',
            src: './imgs/tactrainer.png'
        },

    ],
    services: [

        // {title: 'Conference Reviewer: KDD’26 (ADS Track), KDD’26 (DB Track)', date: '2025'},
        {title: 'Teaching Assistant - History of Computer Thoughts, Zhejiang University', date: '2025', description: 'History of Computer Thoughts, Zhejiang University'}
        ],
    awards: [
        {
            title: 'Award of Honor for Graduate of Zhejiang University',
            date: '2024',
        },
        {
            title: 'Graduate with Merit A Performance of Zhejiang University',
            date: '2024',
        },
        {
          title: 'Outstanding Graduate Awards of Zhejiang University',
          date: '2023'
        },
        {
            title: 'Awardee of National Undergraduate Training Program for Innovation and Entrepreneurship',
            date: '2021',
        },
        {
            title: 'First-prize Scholarship of Zhejiang University',
            date: '2020',
        },
        {
            title: 'Second Prize in National Olympiad in Mathematics in Provinces',
            date: '2018',
        },
        {
            title: 'Second Prize in National Olympiad in Physics in Provinces',
            date: '2018',
        },{
            title: 'Third Prize in National Olympiad in Chemistry in Provinces',
            date: '2018',
        },
        {
            title: 'Second Prize in National Olympiad in Biology in Provinces',
            date: '2018',
        }


]
};


export default data;
